import styled from 'styled-components';
import editIcon from '../../icons/edit.svg';
import { PAGES } from '../../constants';
import { useDispatch } from 'react-redux';
import { setEditedFromSummary } from '../../actions/application';

type EditSummaryButtonProps = {
  children: React.ReactNode;
  page: (typeof PAGES)[keyof typeof PAGES];
  onEditClick?: () => void;
  label?: string;
  className?: string;
};

export default function EditSummaryButton({ children, page, onEditClick, label, className }: EditSummaryButtonProps) {
  const dispatch = useDispatch();

  function goTo(page: (typeof PAGES)[keyof typeof PAGES]) {
    dispatch(setEditedFromSummary(true));
    dispatch({ type: page });
    if (onEditClick) onEditClick();
  }

  return (
    <EditButton
      onClick={() => goTo(page)}
      aria-label={label}
      data-cy={label ? `edit-${label}-button` : 'edit-summary-button'}
      data-pendo={label ? `edit-${label}-button` : 'edit-summary-button'}
      className={className}
    >
      <img src={editIcon} alt="Edit" height={16} width={16} />
      <span>{children}</span>
    </EditButton>
  );
}

const EditButton = styled.button`
  display: flex;
  align-items: center;
  gap: 12px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  color: ${({ theme }) => theme.colors.primary.zero};
  text-align: center;
  font-family: ${({ theme }) => theme.font.typeface.primary};
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;

  &:focus,
  &:focus-visible {
    outline: none !important;
  }

  @media (max-width: 768px) {
    font-size: 12px;
    gap: 6px;
  }
`;
